import { requests } from "./api-config";
export const Image = {
  remove: (data) => requests.post(true, "image/remove", JSON.stringify(data)),
  move: (data) => requests.post(true, "image/move", JSON.stringify(data)),
  copy: (data) => requests.post(true, "image/copy", JSON.stringify(data)),
};
